/**
 * Kalibrasyon arastirma verisi — tek kaynak.
 *
 * Bu bulgular gecmis maclar uzerindeki arastirmanin ciktisi; canli
 * hesaplanmiyor. Hem Istatistikler sayfasi hem ana sayfa vitrini buradan
 * okur — iki yerde kopyalanirsa biri guncellenip digeri unutulur.
 *
 * Alan anlamlari:
 *   MKT_DATA   a/b/c = EDGE-A (buyuk ev favorisi), EDGE-B (deplasman),
 *                      EDGE-C (beraberlik) — yuzde puan sapma
 *   DONEM_DATA d[0..4] = sezonun 5 esit dilimi (D1 baslangic -> D5 bitis)
 *              mw/mwb  = hafta ici (midweek) ev / beraberlik sapmasi
 *   MOT_DATA   rh/mh = gercek/piyasa ev kazanma %, ra/ma = deplasman
 */
export const MOT_DATA = {
    "Süper Lig": {
      ev: [
        { s: "Şampiyon lider",      n: 16,  rh: 68.8, mh: 57.5, ra: 12.5, ma: 20.6 },
        { s: "Şampiyon takipçisi",  n: 17,  rh: 64.7, mh: 55.1, ra: 23.5, ma: 23.0 },
        { s: "Avrupa yarışı",       n: 50,  rh: 40.0, mh: 47.9, ra: 32.0, ma: 28.7 },
        { s: "Düşme tehlikesi",     n: 69,  rh: 31.9, mh: 35.6, ra: 43.5, ma: 39.5 },
        { s: "Rahat orta sıra",     n: 171, rh: 46.2, mh: 43.0, ra: 30.4, ma: 31.8 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 17,  rh: 41.2, mh: 33.2, ra: 47.1, ma: 42.2 },
        { s: "Şampiyon takipçisi",  n: 16,  rh: 37.5, mh: 29.6, ra: 31.2, ma: 46.4 },
        { s: "Avrupa yarışı",       n: 59,  rh: 30.5, mh: 40.5, ra: 39.0, ma: 34.8 },
        { s: "Düşme tehlikesi",     n: 69,  rh: 53.6, mh: 49.5, ra: 24.6, ma: 27.2 },
        { s: "Rahat orta sıra",     n: 166, rh: 47.6, mh: 44.3, ra: 30.1, ma: 30.6 },
      ],
    },
    "Premier League": {
      ev: [
        { s: "Şampiyon lider",      n: 16,  rh: 62.5, mh: 61.5, ra: 25.0, ma: 18.4 },
        { s: "Şampiyon takipçisi",  n: 18,  rh: 61.1, mh: 51.0, ra: 27.8, ma: 26.1 },
        { s: "Avrupa yarışı",       n: 49,  rh: 55.1, mh: 51.3, ra: 30.6, ma: 25.7 },
        { s: "Düşme tehlikesi",     n: 74,  rh: 43.2, mh: 38.3, ra: 33.8, ma: 37.0 },
        { s: "Rahat orta sıra",     n: 183, rh: 41.0, mh: 43.6, ra: 34.4, ma: 32.4 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 18,  rh: 55.6, mh: 37.4, ra: 22.2, ma: 38.4 },
        { s: "Şampiyon takipçisi",  n: 17,  rh: 23.5, mh: 33.0, ra: 47.1, ma: 42.9 },
        { s: "Avrupa yarışı",       n: 48,  rh: 37.5, mh: 35.8, ra: 37.5, ma: 39.4 },
        { s: "Düşme tehlikesi",     n: 73,  rh: 47.9, mh: 50.9, ra: 28.8, ma: 26.6 },
        { s: "Rahat orta sıra",     n: 182, rh: 44.5, mh: 45.0, ra: 35.7, ma: 31.0 },
      ],
    },
    "La Liga": {
      ev: [
        { s: "Şampiyon lider",      n: 17,  rh: 64.7, mh: 54.9, ra: 29.4, ma: 23.2 },
        { s: "Şampiyon takipçisi",  n: 17,  rh: 58.8, mh: 54.2, ra: 11.8, ma: 22.3 },
        { s: "Avrupa yarışı",       n: 53,  rh: 54.7, mh: 50.3, ra: 18.9, ma: 25.0 },
        { s: "Düşme tehlikesi",     n: 87,  rh: 51.7, mh: 37.7, ra: 25.3, ma: 36.0 },
        { s: "Rahat orta sıra",     n: 166, rh: 44.6, mh: 43.0, ra: 34.3, ma: 30.2 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 15,  rh: 40.0, mh: 37.9, ra: 33.3, ma: 38.0 },
        { s: "Şampiyon takipçisi",  n: 17,  rh: 41.2, mh: 40.1, ra: 47.1, ma: 36.8 },
        { s: "Avrupa yarışı",       n: 56,  rh: 35.7, mh: 34.9, ra: 35.7, ma: 38.9 },
        { s: "Düşme tehlikesi",     n: 71,  rh: 46.5, mh: 48.3, ra: 26.8, ma: 25.6 },
        { s: "Rahat orta sıra",     n: 172, rh: 57.0, mh: 46.6, ra: 22.7, ma: 27.4 },
      ],
    },
    "Bundesliga": {
      ev: [
        { s: "Şampiyon lider",      n: 17,  rh: 58.8, mh: 57.8, ra: 29.4, ma: 23.0 },
        { s: "Şampiyon takipçisi",  n: 22,  rh: 50.0, mh: 56.5, ra: 31.8, ma: 21.7 },
        { s: "Avrupa yarışı",       n: 55,  rh: 50.9, mh: 48.4, ra: 29.1, ma: 28.5 },
        { s: "Düşme tehlikesi",     n: 78,  rh: 39.7, mh: 39.3, ra: 29.5, ma: 36.2 },
        { s: "Rahat orta sıra",     n: 154, rh: 38.3, mh: 44.1, ra: 32.5, ma: 32.2 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 19,  rh: 26.3, mh: 30.1, ra: 47.4, ma: 48.6 },
        { s: "Şampiyon takipçisi",  n: 18,  rh: 44.4, mh: 39.3, ra: 38.9, ma: 37.9 },
        { s: "Avrupa yarışı",       n: 49,  rh: 46.9, mh: 39.1, ra: 38.8, ma: 37.1 },
        { s: "Düşme tehlikesi",     n: 88,  rh: 36.4, mh: 48.3, ra: 27.3, ma: 27.6 },
        { s: "Rahat orta sıra",     n: 155, rh: 43.2, mh: 46.8, ra: 29.7, ma: 29.5 },
      ],
    },
    "Serie A": {
      ev: [
        { s: "Şampiyon lider",      n: 18,  rh: 50.0, mh: 56.9, ra: 16.7, ma: 20.6 },
        { s: "Şampiyon takipçisi",  n: 13,  rh: 38.5, mh: 52.4, ra: 53.8, ma: 24.0 },
        { s: "Avrupa yarışı",       n: 50,  rh: 46.0, mh: 51.2, ra: 20.0, ma: 24.6 },
        { s: "Düşme tehlikesi",     n: 72,  rh: 36.1, mh: 37.0, ra: 44.4, ma: 37.0 },
        { s: "Rahat orta sıra",     n: 187, rh: 41.2, mh: 40.2, ra: 32.1, ma: 34.2 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 16,  rh: 43.8, mh: 34.3, ra: 25.0, ma: 41.1 },
        { s: "Şampiyon takipçisi",  n: 13,  rh: 46.2, mh: 32.7, ra: 30.8, ma: 40.3 },
        { s: "Avrupa yarışı",       n: 58,  rh: 29.3, mh: 33.3, ra: 43.1, ma: 41.3 },
        { s: "Düşme tehlikesi",     n: 74,  rh: 50.0, mh: 50.0, ra: 21.6, ma: 25.8 },
        { s: "Rahat orta sıra",     n: 180, rh: 43.3, mh: 43.0, ra: 33.9, ma: 31.4 },
      ],
    },
    "Ligue 1": {
      ev: [
        { s: "Şampiyon lider",      n: 17,  rh: 58.8, mh: 59.8, ra: 17.6, ma: 19.3 },
        { s: "Şampiyon takipçisi",  n: 14,  rh: 57.1, mh: 58.1, ra: 35.7, ma: 20.2 },
        { s: "Avrupa yarışı",       n: 49,  rh: 63.3, mh: 55.2, ra: 22.4, ma: 22.9 },
        { s: "Düşme tehlikesi",     n: 76,  rh: 32.9, mh: 34.9, ra: 43.4, ma: 40.4 },
        { s: "Rahat orta sıra",     n: 170, rh: 41.8, mh: 41.3, ra: 33.5, ma: 34.0 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 14,  rh: 21.4, mh: 23.4, ra: 71.4, ma: 56.7 },
        { s: "Şampiyon takipçisi",  n: 21,  rh: 38.1, mh: 38.6, ra: 42.9, ma: 37.5 },
        { s: "Avrupa yarışı",       n: 48,  rh: 50.0, mh: 33.3, ra: 27.1, ma: 42.3 },
        { s: "Düşme tehlikesi",     n: 78,  rh: 41.0, mh: 50.4, ra: 33.3, ma: 25.8 },
        { s: "Rahat orta sıra",     n: 165, rh: 45.5, mh: 45.0, ra: 34.5, ma: 31.0 },
      ],
    },
    "Eredivisie": {
      ev: [
        { s: "Şampiyon lider",      n: 18,  rh: 38.9, mh: 48.9, ra: 27.8, ma: 29.1 },
        { s: "Şampiyon takipçisi",  n: 20,  rh: 60.0, mh: 51.8, ra: 20.0, ma: 28.0 },
        { s: "Avrupa yarışı",       n: 58,  rh: 46.6, mh: 51.3, ra: 27.6, ma: 28.1 },
        { s: "Düşme tehlikesi",     n: 79,  rh: 38.0, mh: 39.0, ra: 40.5, ma: 36.9 },
        { s: "Rahat orta sıra",     n: 149, rh: 47.0, mh: 45.4, ra: 28.9, ma: 31.5 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 19,  rh: 47.4, mh: 34.3, ra: 42.1, ma: 44.7 },
        { s: "Şampiyon takipçisi",  n: 15,  rh: 13.3, mh: 36.1, ra: 40.0, ma: 42.1 },
        { s: "Avrupa yarışı",       n: 55,  rh: 40.0, mh: 40.4, ra: 43.6, ma: 36.8 },
        { s: "Düşme tehlikesi",     n: 81,  rh: 49.4, mh: 52.7, ra: 19.8, ma: 25.3 },
        { s: "Rahat orta sıra",     n: 157, rh: 48.4, mh: 45.1, ra: 30.6, ma: 31.6 },
      ],
    },
    "Primeira Liga": {
      ev: [
        { s: "Şampiyon lider",      n: 16,  rh: 62.5, mh: 60.5, ra: 12.5, ma: 17.8 },
        { s: "Şampiyon takipçisi",  n: 20,  rh: 60.0, mh: 59.6, ra: 25.0, ma: 19.9 },
        { s: "Avrupa yarışı",       n: 56,  rh: 42.9, mh: 50.8, ra: 23.2, ma: 25.3 },
        { s: "Düşme tehlikesi",     n: 81,  rh: 37.0, mh: 37.6, ra: 44.4, ma: 37.2 },
        { s: "Rahat orta sıra",     n: 149, rh: 41.6, mh: 39.3, ra: 36.2, ma: 34.6 },
      ],
      dep: [
        { s: "Şampiyon lider",      n: 18,  rh: 38.9, mh: 33.7, ra: 44.4, ma: 41.3 },
        { s: "Şampiyon takipçisi",  n: 19,  rh: 21.1, mh: 30.1, ra: 47.4, ma: 44.9 },
        { s: "Avrupa yarışı",       n: 55,  rh: 27.3, mh: 30.9, ra: 47.3, ma: 44.4 },
        { s: "Düşme tehlikesi",     n: 81,  rh: 50.6, mh: 49.0, ra: 27.2, ma: 27.1 },
        { s: "Rahat orta sıra",     n: 150, rh: 47.3, mh: 45.7, ra: 31.3, ma: 28.6 },
      ],
    },
  };

export const MKT_DATA = [
    { l: "Premier League", n: 1879, a: "+0.6", b: "+1.5", c: "-7.1", app: "dep+2pp, ber-3pp", sig: "Beraberlik TERSİNE -7.1pp" },
    { l: "La Liga",        n: 1870, a: "+10.3", b: "+2.5", c: "+3.1", app: "ev+4pp, dep+2pp", sig: "Büyük ev favorisi +10.3pp" },
    { l: "Bundesliga",     n: 1521, a: "+2.9", b: "-0.5", c: "—", app: "ev+3pp", sig: "Deplasman edge yok" },
    { l: "Serie A",        n: 1879, a: "+2.4", b: "+5.0", c: "+4.3", app: "dep+5pp, ber+3pp", sig: "Dep + beraberlik kombinasyonu" },
    { l: "Ligue 1",        n: 1741, a: "+6.3", b: "+1.3", c: "+1.2", app: "ev+3pp, dep+2pp", sig: "Büyük ev favorisi +6.3pp" },
    { l: "Süper Lig",      n: 1752, a: "+7.0", b: "+3.8", c: "+11.3", app: "ev+4pp, dep+5pp, ber+2pp", sig: "Beraberlik en güçlü +11.3pp" },
    { l: "Eredivisie",     n: 1521, a: "-2.0", b: "+0.4", c: "—", app: "dep+2pp", sig: "Büyük ev fav negatif" },
    { l: "Primeira Liga",  n: 1521, a: "+1.4", b: "+6.1", c: "-2.9", app: "dep+5pp, ber-3pp", sig: "Deplasman en güçlü edge" },
    { l: "Championship",   n: 2760, a: "+1.8", b: "+0.7", c: "+0.4", app: "dep+2pp", sig: "Sinyaller zayıf" },
    { l: "2. Bundesliga",  n: 1521, a: "+4.4", b: "+1.6", c: "—", app: "ev+3pp, dep+2pp", sig: "Büyük ev fav orta güç" },
    { l: "Serie B",        n: 1898, a: "+13.2", b: "+0.8", c: "+6.0", app: "ev+5pp, ber+3pp", sig: "Büyük ev favorisi çok güçlü" },
    { l: "Ligue 2",        n: 1751, a: "+7.9", b: "+0.9", c: "+2.0", app: "ev+5pp, dep+2pp", sig: "Büyük ev favorisi güçlü" },
    { l: "Pro League",     n: 1523, a: "+0.4", b: "+3.8", c: "—", app: "dep+3pp", sig: "Dep 4/5 sezonda tutarlı" },
    { l: "Scottish Prem.", n: 1128, a: "-3.7", b: "-2.1", c: "-8.9", app: "ber-3pp", sig: "Tüm edge değerleri TERSİNE" },
  ];

export const DONEM_DATA = [
    { l: "Premier League", d: ["-1.1","+2.1","-5.8","-1.0","+0.6"], mw: "-2.7", mwb: "+2.9", k: "D3 ev çöküşü -5.8pp" },
    { l: "Serie A",        d: ["-4.1","-1.0","-6.3","+2.1","-2.7"], mw: "-8.7", mwb: "+7.6", k: "Midweek ev -8.7pp, ber +7.6pp" },
    { l: "Eredivisie",     d: ["+0.5","-0.4","-8.1","+1.3","+1.7"], mw: "-5.3", mwb: "+6.9", k: "D3 en derin çöküş -8.1pp" },
    { l: "Süper Lig",      d: ["-2.2","+2.0","+0.8","+5.5","-0.2"], mw: "+0.0", mwb: "+0.0", k: "D4 ev patlaması +5.5pp" },
    { l: "Bundesliga",     d: ["-4.1","+4.0","+3.0","-0.5","-4.5"], mw: "+7.2", mwb: "-5.9", k: "Midweek ev güçlü +7.2pp" },
    { l: "La Liga",        d: ["+0.0","+1.2","+3.2","+1.5","+0.8"], mw: "+3.0", mwb: "+0.0", k: "Genel ev avantajı stabil" },
    { l: "Ligue 1",        d: ["+1.0","+2.1","+1.5","-0.8","+0.4"], mw: "+2.5", mwb: "+0.0", k: "Sabit ev avantajı" },
    { l: "Scottish Prem.", d: ["+0.0","+1.9","+3.1","+2.0","+5.7"], mw: "+3.6", mwb: "+0.0", k: "D5 sezon sonu ev güçlü +5.7pp" },
  ];

export const TAKIM_POS = [
    { t: "Troyes", l: "Ligue 2", n: 53, e: "+19.7pp" },
    { t: "Heidenheim", l: "2. Bundesliga", n: 51, e: "+18.9pp" },
    { t: "Toulouse", l: "Ligue 2", n: 38, e: "+16.6pp" },
    { t: "Volendam", l: "Eredivisie", n: 33, e: "+16.2pp" },
    { t: "St. Gilloise", l: "Pro League", n: 73, e: "+13.6pp" },
    { t: "Inter", l: "Serie A", n: 94, e: "+10.0pp" },
  ];
export const TAKIM_NEG = [
    { t: "Hertha BSC", l: "2. Bundesliga", n: 34, e: "-17.8pp" },
    { t: "Chelsea", l: "Premier League", n: 94, e: "-14.1pp" },
    { t: "Atalanta", l: "Serie A", n: 94, e: "-11.6pp" },
  ];
